import { EventEmitter, Injectable, Output } from "@angular/core"

import { QuestionType } from "~types"

import { DbService } from "./db.service"

export const QUESTION_TYPES = ["trivia", "predict", "recall"] as QuestionType[]

export interface LoyaltyAmountsConfig {
  startingBalance: number
  registerBonus: number
  dailyLoginBonus: number

  correctAnswerBonus: number
  surviveRoundBonus: number

  answerAllBonus: number

  winningGroupBonus: number
  consolationGroupBonus: number
}

export interface ConfigVals {
  stepValue: number
  coinValue: number
}

export interface Config {
  games: string[]
  defaultStepMultiplier: number
  defaultCoinMultiplier: number
  defaultManagementFee: number
  startingStepValue: number
  loyaltyAmounts: LoyaltyAmountsConfig
  po_identy_map: { [key: string]: string }
  trivia: ConfigVals
  predict: ConfigVals
  recall: ConfigVals
  excludePaid: boolean
}

@Injectable({
  providedIn: "root"
})
export class ConfigService {
  config_id = "initialVals"
  @Output() ready: EventEmitter<null> | null = new EventEmitter()

  private _config!: Config

  constructor(private dbService: DbService) {
    this.getConfig$().subscribe((config) => {
      this._config = config

      if (this.ready) {
        this.ready!.emit(null)
        this.ready = null
      }
    })
  }

  public get config() {
    return this._config
  }

  public getConfig() {
    return this.dbService.getItemSnapshot<Config>("config", this.config_id)
  }

  public getConfig$() {
    return this.dbService.getItem<Config>("config", this.config_id)
  }

  public updateConfig(config: Config) {
    return this.dbService.updateItem("config", this.config_id, config)
  }
}
